import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as S from '../../TermsStyles';

export const Check = ({ label, handlerCheck }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isTouched, setIsTouched] = useState(false);

  const handlerChangeOptions = () => {
    setIsChecked(!isChecked);
    setIsTouched(true);
  };

  useEffect(() => {
    if (isTouched) {
      handlerCheck(isChecked);
    }
  }, [isChecked]); // eslint-disable-line

  return (
    <S.Check
      checked={isChecked}
      onChange={handlerChangeOptions}
      label={label}
    />
  );
};

Check.propTypes = {
  label: PropTypes.element,
  handlerCheck: PropTypes.func
};
